<div class="dialog-title-content">
  <div class="dialog-title">{{'modules.crm.leads.changeStatusDialog.title' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>

<div class="dialog-content scroll-content-padding">

  <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="margin-top: 20px">
    <mat-label>{{data.label | translate}}</mat-label>
    <mat-select class="select-panel" panelClass="dialog-select-panel" [disableOptionCentering]="true" [formControl]="option">
      <mat-option *ngFor="let option of data.options" [value]="option">
        {{data.optionsTranslation + option | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</div>

<div class="buttons-row df jc-e ai-c gap20">
  <button class="default-button apply-button-flat" (click)="closeDialog(true, option.value)">
    {{data.button | translate}}
  </button>
</div>
